import { render } from "./ProfesionalesListado.vue?vue&type=template&id=7a0dee1c&ts=true"
import script from "./ProfesionalesListado.vue?vue&type=script&lang=ts"
export * from "./ProfesionalesListado.vue?vue&type=script&lang=ts"

import "./ProfesionalesListado.vue?vue&type=style&index=0&id=7a0dee1c&lang=scss"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__